import {
  changeJobStatus,
  ChangeJobStatus,
  deletePlanTask,
  DeleteTask,
  getBizAreaList,
  GetPlanTaskDetail,
  getPlanTaskDetail,
  GetPlanTaskList,
  getPlanTaskList,
} from '@/api/data-protection/plan-list'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { BizAreaItem } from '../task-list/utils'
import { t } from '@/i18n'

export type TaskListItem = {
  id: string
  task_id: string
  name: string
  create_time: string
  start_time: string
  end_time: string
  protect_status: number | string // 1：全部成功；2：部分成功；3：全部失败
  target: string
  biz_area_name: string
  result_status: number
  task_status: number //1:暂停 2:运行中 3:已完成
  scheduler_type: number //1:立即;2:预定;3每日;4:每周;5:每月
  task_time?: string
  day_list?: string[]
  day_of_week?: string[]
  except_reason?: string //任务异常时异常原因
  task_name: string
  /**保护成功的数量 */
  success?: number
  /**保护失败的数量 */
  failed?: number
}

export interface TaskListResult {
  items: TaskListItem[]
  total: number
}

// 获取计划任务列表
export const useGetPlanList = (props: GetPlanTaskList) => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(() => getPlanTaskList(props), {
    refreshDeps: [props],
    onError(err: any) {
      Message.error(err?.msg || t('获取计划任务列表失败'))
    },
  })
  return [run, data?.data as TaskListResult, loading] as const
}

// TODO:获取安全域列表
export const useGetBizAreaList = () => {
  const { data } = useRequest(() => getBizAreaList(), {
    onError(err: any) {
      Message.error(err?.msg || t('获取安全域列表失败'))
    },
  })

  return [(data?.data?.items as BizAreaItem[]) || []] as const
}

// 获取计划详情
export const useGetJobDetail = () => {
  const { runAsync: run, data } = useRequest(
    (params: GetPlanTaskDetail) => getPlanTaskDetail(params),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('获取计划详情失败'))
      },
    },
  )

  return [run, data?.data || []] as const
}

// TODO:暂停/重启计划任务
export const useChangeJobStatus = () => {
  const { runAsync: run } = useRequest((params: ChangeJobStatus) => changeJobStatus(params), {
    manual: true,
    onError(err: any) {
      // Message.error(err?.msg || '暂停/重启计划任务')
    },
  })

  return [run] as const
}

// 删除任务列表 批量单个合为一个接口
export const useDeleteTask = () => {
  const { runAsync: run } = useRequest((data: DeleteTask) => deletePlanTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除任务列表失败'))
    },
  })

  return [run] as const
}
